import { useState } from 'react';
import { NButton, NInput, useLocalStorage, useToast } from 'nayan';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { StorageService } from '../../services/StorageService.ts';

const Login = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const search = useLocation().search;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [uuid] = useLocalStorage('UUID', '');
  const redirect: any = new URLSearchParams(search).get('redirect') || '/categories';

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (!email || !password) {
      toast('You have to enter required details to continue.');
      return;
    }
    if (email === 'niranjan.devasani@gmail.com' && password === 'njnjnj') {
      StorageService.set('UUID', 'bf0bcc14-1724-40bf-86b0-c45a892e34de');
      navigate(redirect, { replace: true });
    } else {
      toast('Wrong credentials, try again with correct credentials');
    }
  };

  if (!!uuid) {
    return <Navigate to="/categories" />;
  }

  return (
    <div className="sm:w-full md:max-w-[400px] p-3 mx-auto mt-5">
      <form onSubmit={onSubmit}>
        <NInput className="mb-3 card-input mt-5" label="Email" type="email" onChange={e => setEmail(e.target.value)} required={true} />
        <NInput className="mb-3 card-input" label="Password" type="password" onChange={e => setPassword(e.target.value)} required={true} />
        <NButton type="submit" className="w-full mb-3">
          LOGIN
        </NButton>
      </form>
    </div>
  );
};

export default Login;
